/**
 * Copyright (c) 2026 Stefan Radig
 *
 * The licences page: shows LICENSE and the dependency list from licenses.md.
 */

function setTextById(id: string, text: string): void {
    const element = document.getElementById(id);
    if (element) element.textContent = text;
}

/** Just enough Markdown for licenses.md: headings, emphasis, links, lists, tables. */
export function renderLicensesMarkdown(text: string): string {
    return text
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank">$1</a>')
        .replace(/^- (.*$)/gim, '<li>$1</li>')
        .replace(/(<li>.*<\/li>)/s, '<ul class="dependency-list">$1</ul>')
        .replace(/\n\n/g, '</p><p>')
        .replace(/\|(.+)\|/g, match => {
            const cells = match.split('|').filter(Boolean);
            return '<tr>' + cells.map(cell => '<td>' + cell.trim() + '</td>').join('') + '</tr>';
        });
}

/** Turns the loose table rows the Markdown pass produced into one real table. */
function wrapTableRows(container: HTMLElement): void {
    const rows = container.querySelectorAll('tr');
    if (rows.length === 0) return;

    let tableHtml = '<table>';
    rows.forEach((row, idx) => {
        if (idx === 0) {
            tableHtml += '<thead>' + row.outerHTML.replace(/<td>/g, '<th>').replace(/<\/td>/g, '</th>') + '</thead><tbody>';
        } else if (idx === 1 && row.textContent?.includes('---')) {
            // Skip separator row
        } else {
            tableHtml += row.outerHTML;
        }
    });
    tableHtml += '</tbody></table>';

    const firstRow = container.querySelector('tr');
    const parent = firstRow?.parentElement;
    if (!parent) return;
    while (parent.querySelector('tr')) {
        parent.removeChild(parent.querySelector('tr')!);
    }
    parent.innerHTML = tableHtml;
}

function switchTab(tab: string): void {
    document.querySelectorAll('.tab-content').forEach(el => el.classList.remove('active'));
    document.querySelectorAll<HTMLElement>('.tab-button').forEach(el => {
        el.classList.toggle('active', el.dataset.tab === tab);
    });
    document.getElementById(tab === 'main' ? 'main-tab' : 'dependencies-tab')?.classList.add('active');
}

document.querySelectorAll<HTMLElement>('.tab-button[data-tab]').forEach(button => {
    button.addEventListener('click', () => switchTab(button.dataset.tab || 'main'));
});

fetch('LICENSE')
    .then(response => response.text())
    .then(text => setTextById('main-license', text))
    .catch(err => setTextById('main-license', 'Error loading LICENSE file: ' + (err as Error).message));

fetch('licenses.md')
    .then(response => response.text())
    .then(text => {
        const container = document.getElementById('dependencies-content');
        if (!container) return;
        container.innerHTML = '<div>' + renderLicensesMarkdown(text) + '</div>';
        wrapTableRows(container);
    })
    .catch(err => {
        const container = document.getElementById('dependencies-content');
        if (container) container.textContent = 'Error loading licenses.md file: ' + (err as Error).message;
    });
